export const severityGrids = {
  addSeverityGrid: "Add a severity grid",
  create: {
    title: "Create a new severity grid",
  },
  delete: {
    label: "Delete severity grid",
  },
  form: {
    name: { label: "Name" },
    description: { label: "Description" },
    translation: { label: "Translation" },
  },
  list: {
    name: "Name",
  },
};
